import React from 'react';
import ReactDOM from 'react-dom';
import packageJson from './meta.json';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


global.appVersion = packageJson.version;
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();